/* ============================================================
   Maison Atelier Premium — theme.js
   Utilities globali + UI condivisa (vanilla JS, no dipendenze)
   ============================================================ */
(function () {
  'use strict';

  window.theme = window.theme || {};
  var settings = window.theme.settings || {};
  var strings = window.theme.strings || {};

  /* ---------------- Utils ---------------- */
  var utils = {
    debounce: function (fn, wait) {
      var t;
      return function () {
        var ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    },
    rafThrottle: function (fn) {
      var queued = false;
      return function () {
        var ctx = this, args = arguments;
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fn.apply(ctx, args); });
      };
    },
    formatMoney: function (cents) {
      var value = (cents / 100).toLocaleString(document.documentElement.lang || 'it', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      var format = settings.moneyFormat || '€{{amount}}';
      return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
    },
    fetchConfig: function (type) {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: null,
        _type: type
      };
    },
    getFocusable: function (el) {
      return Array.prototype.slice.call(el.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
    }
  };
  window.theme.utils = utils;

  /* ---------------- Body scroll + backdrop ---------------- */
  var backdrop = document.querySelector('[data-overlay-backdrop]');
  var openOverlays = 0;
  function lockScroll() {
    openOverlays++;
    document.body.classList.add('overlay-open');
    if (backdrop) { backdrop.hidden = false; requestAnimationFrame(function () { backdrop.classList.add('is-active'); }); }
  }
  function unlockScroll() {
    openOverlays = Math.max(0, openOverlays - 1);
    if (openOverlays === 0) {
      document.body.classList.remove('overlay-open');
      if (backdrop) {
        backdrop.classList.remove('is-active');
        setTimeout(function () { if (openOverlays === 0) backdrop.hidden = true; }, 320);
      }
    }
  }

  /* ---------------- Focus trap ---------------- */
  function FocusTrap(container) {
    this.container = container;
    this.previous = null;
    this.handler = this._onKeydown.bind(this);
  }
  FocusTrap.prototype.activate = function () {
    this.previous = document.activeElement;
    document.addEventListener('keydown', this.handler);
    var focusable = utils.getFocusable(this.container);
    (focusable[0] || this.container).focus();
  };
  FocusTrap.prototype.deactivate = function () {
    document.removeEventListener('keydown', this.handler);
    if (this.previous && typeof this.previous.focus === 'function') this.previous.focus();
  };
  FocusTrap.prototype._onKeydown = function (e) {
    if (e.key !== 'Tab') return;
    var focusable = utils.getFocusable(this.container);
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  window.theme.FocusTrap = FocusTrap;

  /* ---------------- Drawer / Overlay controller ---------------- */
  var activePanels = [];
  function promotePanel(panel) {
    if (!panel || panel.parentElement === document.body) return;
    if (!panel._originalParent) {
      panel._originalParent = panel.parentNode;
      panel._originalNextSibling = panel.nextSibling;
    }
    document.body.appendChild(panel);
  }
  function restorePanel(panel) {
    if (!panel || !panel._originalParent) return;
    if (panel._originalNextSibling && panel._originalNextSibling.parentNode === panel._originalParent) {
      panel._originalParent.insertBefore(panel, panel._originalNextSibling);
    } else {
      panel._originalParent.appendChild(panel);
    }
    panel._originalParent = null;
    panel._originalNextSibling = null;
  }
  function findPanel(selector) {
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (e) {
      if (selector.charAt(0) === '#') return document.getElementById(selector.slice(1));
      return null;
    }
  }
  function syncPanelTriggers(panel, expanded) {
    if (!panel || !panel.id) return;
    document.querySelectorAll('[data-panel-open="#' + panel.id + '"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function openPanel(panel, openClass) {
    if (!panel || panel.classList.contains(openClass)) return;
    promotePanel(panel);
    lockScroll();
    if (panel.id) document.body.classList.add('panel-open-' + panel.id);
    if (panel.id === 'MenuDrawer') {
      document.body.classList.add('menu-drawer-active');
      if (panel.classList.contains('menu-drawer--editorial-black')) {
        document.body.classList.add('menu-drawer-editorial-active');
      }
      var header = document.querySelector('[data-header]');
      if (header) header.classList.add('is-menu-open');
    }
    panel.setAttribute('aria-hidden', 'false');
    if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    void panel.offsetWidth;
    panel.classList.add(openClass);
    syncPanelTriggers(panel, true);
    var trap = new FocusTrap(panel);
    trap.activate();
    panel._trap = trap;
    panel._openClass = openClass;
    activePanels.push(panel);
    document.dispatchEvent(new CustomEvent('panel:open', { detail: { panel: panel } }));
  }
  function closePanel(panel) {
    if (!panel || !panel.classList.contains(panel._openClass || 'is-open')) return;
    if (panel.id) document.body.classList.remove('panel-open-' + panel.id);
    panel.classList.remove(panel._openClass || 'is-open');
    panel.setAttribute('aria-hidden', 'true');
    syncPanelTriggers(panel, false);
    if (panel.id === 'MenuDrawer') {
      document.body.classList.remove('menu-drawer-active');
      document.body.classList.remove('menu-drawer-editorial-active');
      var header = document.querySelector('[data-header]');
      if (header) header.classList.remove('is-menu-open');
    }
    if (panel._trap) panel._trap.deactivate();
    activePanels = activePanels.filter(function (p) { return p !== panel; });
    unlockScroll();
    document.dispatchEvent(new CustomEvent('panel:close', { detail: { panel: panel } }));
    var restoreDelay = panel.id === 'MenuDrawer' ? 980 : 580;
    setTimeout(function () { restorePanel(panel); }, restoreDelay);
  }
  function closeTopPanel() {
    var panel = activePanels[activePanels.length - 1];
    if (panel) closePanel(panel);
  }
  window.theme.openPanel = openPanel;
  window.theme.closePanel = closePanel;

  // Triggers
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      var sel = opener.getAttribute('data-panel-open');
      var openClass = opener.getAttribute('data-open-class') || 'is-open';
      openPanel(findPanel(sel), openClass);
      return;
    }
    var closer = e.target.closest('[data-panel-close]');
    if (closer) {
      e.preventDefault();
      var parent = closer.closest('[aria-hidden]') || closer.closest('.drawer, .search-overlay, .modal');
      closePanel(parent);
    }
  });
  if (backdrop) backdrop.addEventListener('click', closeTopPanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTopPanel();
  });

  /* ---------------- Header transparent + scroll ---------------- */
  (function header() {
    var header = document.querySelector('[data-header]');
    var announcement = document.querySelector('.announcement-bar, .announcement-marquee');
    if (!header) return;
    var transparent = header.classList.contains('is-transparent');
    var sticky = header.getAttribute('data-sticky') === 'true';
    var lastY = window.scrollY || 0;
    var minDelta = 6;

    function syncAnnouncementOffset() {
      var height = announcement ? Math.max(0, announcement.offsetHeight - (window.scrollY || 0)) : 0;
      document.documentElement.style.setProperty('--ann-height', height + 'px');
    }

    function syncHeaderHeight() {
      if (!sticky) return;
      syncAnnouncementOffset();
      document.documentElement.style.setProperty('--active-header-height', header.offsetHeight + 'px');
    }

    function revealHeader() {
      if (!sticky) return;
      header.classList.remove('is-hidden');
      header.classList.add('is-revealed');
    }

    var onScroll = utils.rafThrottle(function () {
      var y = window.scrollY || 0;
      var delta = y - lastY;

      if (sticky) syncAnnouncementOffset();

      if (transparent) header.classList.toggle('is-scrolled', y > 60);

      if (sticky && !header.classList.contains('is-menu-open') && !document.body.classList.contains('overlay-open')) {
        if (y <= 10 || delta < -minDelta) {
          revealHeader();
        } else if (delta > minDelta && y > header.offsetHeight + 40) {
          header.classList.add('is-hidden');
          header.classList.remove('is-revealed');
        }
      }

      lastY = y;
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', utils.debounce ? utils.debounce(syncHeaderHeight, 150) : syncHeaderHeight);
    document.addEventListener('mousemove', function (event) {
      if (event.clientY <= 48) revealHeader();
    }, { passive: true });
    document.addEventListener('touchstart', function (event) {
      var touch = event.touches && event.touches[0];
      if (touch && touch.clientY <= 48) revealHeader();
    }, { passive: true });
    syncHeaderHeight();
    onScroll();
  })();

  /* ---------------- Announcement bar rotation ---------------- */
  (function announcement() {
    var bar = document.querySelector('[data-announcement][data-autoplay="true"]');
    if (!bar) return;
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 5000);
  })();

  /* ---------------- Accordion ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.accordion__toggle');
    if (!toggle) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.style.maxHeight = expanded ? '0px' : panel.scrollHeight + 'px';
  });

  /* ---------------- Footer accordion ---------------- */
  (function footerAccordions() {
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var resizeHandler = utils.debounce(function () { syncFooterAccordions(document); }, 120);

    function getFooterToggles(root) {
      return Array.prototype.slice.call((root || document).querySelectorAll('[data-footer-accordion-toggle]'));
    }

    function setPanelInteractive(panel, enabled) {
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]');
      if ('inert' in panel) panel.inert = !enabled;
      Array.prototype.forEach.call(focusable, function (item) {
        if (enabled) {
          if (item.hasAttribute('data-footer-tabindex')) {
            var previous = item.getAttribute('data-footer-tabindex');
            if (previous) item.setAttribute('tabindex', previous);
            else item.removeAttribute('tabindex');
            item.removeAttribute('data-footer-tabindex');
          }
          return;
        }
        if (!item.hasAttribute('data-footer-tabindex')) {
          item.setAttribute('data-footer-tabindex', item.getAttribute('tabindex') || '');
        }
        item.setAttribute('tabindex', '-1');
      });
    }

    function setFooterAccordion(toggle, expanded) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;

      if (!mobileQuery.matches) {
        toggle.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        panel.style.maxHeight = 'none';
        setPanelInteractive(panel, true);
        return;
      }

      toggle.setAttribute('aria-expanded', String(expanded));
      panel.setAttribute('aria-hidden', String(!expanded));
      panel.style.maxHeight = expanded ? panel.scrollHeight + 'px' : '0px';
      setPanelInteractive(panel, expanded);
    }

    function syncFooterAccordions(root) {
      getFooterToggles(root).forEach(function (toggle) {
        var expanded = toggle.getAttribute('data-footer-open') === 'true';
        setFooterAccordion(toggle, expanded);
      });
    }

    function initFooterAccordions(root) {
      getFooterToggles(root).forEach(function (toggle) {
        if (toggle.getAttribute('data-footer-accordion-ready') === 'true') return;
        toggle.setAttribute('data-footer-accordion-ready', 'true');
        toggle.setAttribute('data-footer-open', 'false');
        toggle.addEventListener('click', function () {
          if (!mobileQuery.matches) return;
          var next = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('data-footer-open', String(next));
          setFooterAccordion(toggle, next);
        });
      });
      syncFooterAccordions(root);
    }

    initFooterAccordions(document);
    window.addEventListener('resize', resizeHandler, { passive: true });
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () { syncFooterAccordions(document); });
    } else {
      mobileQuery.addListener(function () { syncFooterAccordions(document); });
    }
    document.addEventListener('shopify:section:load', function (event) {
      initFooterAccordions(event.target);
    });
  })();

  /* ---------------- Quantity selector ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-button]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input[type="number"]');
    if (!input) return;
    var step = btn.getAttribute('data-qty-button') === 'plus' ? 1 : -1;
    var min = parseInt(input.min || '1', 10);
    var value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Wishlist → assets/wishlist.js · Recently viewed → assets/recently-viewed.js */

  /* ---------------- Size guide modal ---------------- */
  (function sizeGuide() {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-size-tab]');
      if (!tab) return;
      var modal = tab.closest('.modal');
      modal.querySelectorAll('[data-size-tab]').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      modal.querySelectorAll('[data-size-panel]').forEach(function (p) { p.hidden = true; });
      tab.setAttribute('aria-selected', 'true');
      var panel = modal.querySelector('[data-size-panel="' + tab.getAttribute('data-size-tab') + '"]');
      if (panel) panel.hidden = false;
    });
  })();

  /* ---------------- Sticky ATC ---------------- */
  (function stickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var form = document.querySelector('form.product-form, [data-product-form]');
    var trigger = document.querySelector('[data-add-button]') || form;
    if (!sticky || !form || !trigger) return;
    var update = utils.rafThrottle(function () {
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64;
      var rect = trigger.getBoundingClientRect();
      sticky.classList.toggle('is-visible', rect.bottom <= headerHeight);
    });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  /* ---------------- Cart count updater (global) ---------------- */
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-panel-open="#CartDrawer"], a[href$="/cart"]').forEach(function (el) {
      el.classList.remove('is-pulsing');
      void el.offsetWidth;
      el.classList.add('is-pulsing');
    });
  });

})();
